import React from 'react';
import Photo from '../../../resource/My photo.png'
import Projects from '../Projects/Projects';
import { useNavigate } from "react-router-dom";
import {  Zoom  } from 'react-reveal';
import Fade from "react-reveal/Fade";
import Education from '../../Education/Education';
import Skills from '../../Skills/Skills';

const Home = () => {
  const navigate = useNavigate();
    return (
      <div>
        <div className="hero min-h-screen bg-slate-100">
          <div className="hero-content text-center">
            <div className="max-w-md">
              <div className="avatar">
                <Zoom right>
                  <div className="w-64 mb-10 rounded-full ring ring-slate-100 ring-offset-base-100 ring-offset-2">
                    <img src={Photo} alt="Solih Ahmad Sohan" />
                  </div>
                </Zoom>
              </div>
              <Fade left delay={800}>
                <h1 className="text-4xl text-yellow-500 font-bold uppercase">
                  {" "}
                  Solih Ahmad Sohan
                </h1>
              </Fade>
              <Fade right delay={1500}>
                <h3 className="text-3xl text-black font-bold uppercase">
                  MERN Stack Developer
                </h3>
              </Fade>

              <p className="py-6 text-black">
                I’m a passionate web developer skilled in the MERN stack. With a
                focus on both frontend and backend development, I create dynamic
                web applications. Rigorous testing ensures top-notch quality.
               With a strong foundation in the MERN
                (MongoDB, Express.js, React.js, Node.js) stack, I’m committed to
                creating robust and efficient solutions.
              </p>
              <button
                onClick={() => navigate("/contact")}
                className="btn btn-outline  rounded-full"
              >
                Contact Me{" "}
              </button>
            </div>
          </div>
        </div>
        <div className=''>
          <Education></Education>
        </div>
        
          <Skills></Skills>
        
        <Projects></Projects>
      </div>
    );
};

export default Home;